import { SearchAndSelect } from "src/modules/base/components/form/models/serachselect.model";

export class ChiefComplaintModel {
    datasource = {
        "search_columns":"code,code_description",
        "application": "emr",
        "resource": "diagnosis_classification",
        "query_id": "GET_CLASSIFICATION_DATA",
        "args": "type:Chief Complaint"
    };
    defaultsetting = {
        "singleSelection": false,
        "allowSearchFilter": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": false,
        "apliCall": false,
        "stopPropagation": true,
        "advancesearch": {
            "resource": "diagnosis_classification",
            "datasource": {
                "search_columns":"code,code_description",
                "application": "emr",
                "query_id": "GET_CLASSIFICATION_DATA",
                "args": "type:Chief Complaint"
            }
        }
    };
    question = new SearchAndSelect({
        datasource: this.datasource,
        defaultsetting: this.defaultsetting,
        getterKey: "code_description",
        getterValue:"code_description",
        req_keys: "all",
        options: false,
    });
    showDropdown = true
}